const styles = {
  appBar: {
    backgroundColor: 'neutral.lightest',
    height: 64,
    justifyContent: 'center',
    boxShadow: 1,
  },
  logoContainer: {
    display: 'flex',
    '& > img': { height: 32, width: 'auto' },
  },
  magnifyingGlassButton: {
    mr: 1,
    '& > svg': { width: 32, height: 32 },
  },
  signOutButton: {
    '& > svg': { width: 32, height: 32 },
  },
  loading: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& > svg': { width: 32, height: 32 },
  },
  toolbar: {
    justifyContent: 'space-between',
  },
}

export default styles
